'use client';

import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { Toaster } from 'stylus-ui/Toast';
import { TooltipProvider } from 'stylus-ui/Tooltip';

import { ExtensionStateProvider } from '@/_hooks/useExtensionState/context';
import { ExperimentProvider } from '@/_lib/featureflags/context';
import { getQueryClient } from '@/_lib/getQueryClient';
import { FlagsmithProvider } from '@/_providers/FlagsmithProvider';

export const Providers = ({ children }: { children: React.ReactElement }) => {
  const queryClient = getQueryClient();

  return (
    <TooltipProvider>
      <QueryClientProvider client={queryClient}>
        <FlagsmithProvider>
          <ExperimentProvider>
            <ExtensionStateProvider>
              {children}
              <ReactQueryDevtools initialIsOpen={false} />
            </ExtensionStateProvider>
          </ExperimentProvider>
        </FlagsmithProvider>
      </QueryClientProvider>
      <Toaster />
    </TooltipProvider>
  );
};
